import React from "react";
import { useDocsFilters } from "./filtersContext";
import { Flavor, Platform } from "../../docs/loader";

const FiltersBar: React.FC = () => {
  const {
    selectedPlatforms,
    setSelectedPlatforms,
    selectedFlavors,
    setSelectedFlavors,
  } = useDocsFilters();

  const toggle = <T extends string>(
    arr: T[],
    setArr: (v: T[]) => void,
    value: T
  ) => {
    setArr(
      arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value]
    );
  };

  const platforms: Platform[] = [
    "web",
    "android",
    "ios",
    "windows",
    "macos",
    "linux",
  ];
  const flavors: Flavor[] = ["regular", "ebm"];

  return (
    <div className="mb-4 flex flex-wrap items-center gap-4">
      <div className="flex items-center gap-2 text-sm">
        <span className="text-gray-500">Platforms:</span>
        {platforms.map((p) => (
          <button
            key={p}
            className={`px-2 py-1 rounded border text-xs ${
              selectedPlatforms.includes(p) ? "bg-blue-900 border-blue-300" : ""
            }`}
            onClick={() => toggle(selectedPlatforms, setSelectedPlatforms, p)}
          >
            {p}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2 text-sm">
        <span className="text-gray-500">Flavors:</span>
        {flavors.map((f) => (
          <button
            key={f}
            className={`px-2 py-1 rounded border text-xs ${
              selectedFlavors.includes(f)
                ? "bg-purple-900 border-purple-300"
                : ""
            }`}
            onClick={() => toggle(selectedFlavors, setSelectedFlavors, f)}
          >
            {f}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FiltersBar;
